module.exports = __webpack_public_path__ + "media/categories/2038-0a9fe44e.svg";